module.exports = [{
      plugin: require('/Users/andre/source/paragonia-technology-site/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/andre/source/paragonia-technology-site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
